import BookACall from 'components/BookACall';
import JobQuote from 'components/JobQuote';

import FinanceHelper from './components/FinanceHelper';
import PaymentForm from './components/PaymentForm';
import PaymentSelect from './components/PaymentSelect';
import SecureTransaction from './components/SecureTransaction';
import useJobContentCheckout from './useCheckout';

import JobBackButton from '../JobBackButton';

const JobContentCheckout: React.FunctionComponent = function () {
  const { job, jobCompanyInfo, isLoading } = useJobContentCheckout();
  return (
    <div className="flex flex-col flex-1 max-w-6xl mx-auto">
      <div className="block md:hidden -mx-4 -mt-4">
        <JobQuote
          job={job}
          jobCompanyInfo={jobCompanyInfo}
          isLoading={isLoading}
          variant="compact"
        />
      </div>
      <div className="hidden md:block">
        <div className="-ml-4">
          <JobBackButton />
        </div>
      </div>
      <h1 className="text-20-24-em sm:text-24-28-em md:text-32-40-em mt-4 md:mt-6">
        Choose A Payment Option
      </h1>
      <div className="border-b border-neutral-300 w-full mt-4 md:mt-6 md:mb-10" />
      <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-x-8">
        <div className="flex flex-col col-span-1 md:col-span-7">
          <PaymentSelect />
          <div className="mb-6 md:mb-8" />
          <SecureTransaction />
          <PaymentForm />
          <div className="mb-6 md:mb-8" />
          <FinanceHelper />
        </div>
        <div className="hidden md:block col-span-5">
          <div className="sticky top-24 flex flex-col gap-y-6">
            <BookACall />
            <JobQuote
              job={job}
              jobCompanyInfo={jobCompanyInfo}
              isLoading={isLoading}
              variant="collapsible"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobContentCheckout;
